import { Suspense } from 'react';
import { AppRoutes } from './router';
import { ChatBot } from './components/ChatBot';
import SeoRouteBridge from './components/seo/SeoRouteBridge';
import { useMounted } from './hooks/use-mounted';

// No router here: main.tsx wraps App in BrowserRouter, entry-server.tsx in StaticRouter.
function App() {
  // ChatBot is a closed, browser-only widget (reCAPTCHA, timers): it is not part of the
  // prerendered page and mounts after hydration.
  const mounted = useMounted();
  return (
    <>
      <SeoRouteBridge />
      <Suspense fallback={null}>
        <AppRoutes />
      </Suspense>
      {mounted && <ChatBot />}
    </>
  );
}

export default App;
